module.exports = __webpack_public_path__ + "static/media/Gobi-Happy-Look.6c39f80f.png";